import { render, staticRenderFns } from "./serverSettings.vue?vue&type=template&id=230a4627&scoped=true&lang=pug"
import script from "./serverSettings.vue?vue&type=script&lang=js"
export * from "./serverSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a4627",
  null
  
)

export default component.exports